import { get, post } from '../http';

const fetch = (id, type, dates = null) => {
  const params = [];
  if (id) params.push(`id=${id}`);
  if (type) params.push(`eventType=${type}`);
  if (type==='past' && dates && dates.startDate && dates.endDate) {
    params.push(`startDate=${dates.startDate}`);
    params.push(`endDate=${dates.endDate}`);
  }
  return get('eventsRetrieve' + (params.length ? '?' + params.join('&') : ''));
};
const save = (id, data) => {
  let url = 'eventSave';
  if (id) {
    url += '?id=' + id;
  }
  return post(url, data);
};
const cancel = (data) => post('eventDelete', data);
const createSession = (id, data) => post('sessionCreate?id=' + id, data);
const duplicate = (id) => post('eventDuplicate', { id });
const saveOtherAttendeeData = (id, data) => post('eventSaveOtherAttendeeData?id=' + id, data);
const eventsCSVExportDetail = (data) => post('eventsCSVExportDetail', data);
const exportToCSVSummary = (data) => post('eventsCSVExportSummary', data);
const exportToCSVIncomplete = (data) => post('eventsCSVExportIncomplete', data);

export default {
  fetch,
  save,
  cancel,
  createSession,
  duplicate,
  saveOtherAttendeeData,
  eventsCSVExportDetail,
  exportToCSVSummary,
  exportToCSVIncomplete
};
